import { createStore, createLogger } from 'vuex'
import { IAPPState } from './modules/app'

export interface IRootState {
  app: IAPPState;
}

export default createStore<IRootState>({});